import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
    inheritAttrs: false,
    name: 'log-observation',
})
export default class AttributeLog extends Vue {
    @Prop({ required: true }) icon!: string
    @Prop({ required: true }) translation!: string
    @Prop({ required: true }) color!: string
}
